let language = {
    PRIVACY_POLICY_AGREE_PROCESSED_TEXT: "I agree to my data being processed in accordance with",
    PRIVACY_POLICY_HAVE_READ_TEXT: "I have read and agree to the ",
};

export { language }